import { useEffect, useState } from 'react';

/** True while the viewport matches `query`; updates on resize/rotate. */
export function useMedia(query: string): boolean {
  const [match, setMatch] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return match;
}

/** Phone / small tablet layout: map and details become separate tabs. */
export const MOBILE_QUERY = '(max-width: 820px)';
